import { s, Shape } from "@kosmod/pancake";
import {
  Mini, MiniAnimation, miniAnimationDef, MiniEvent, MiniID, PhysicsDice, PhysicsDiceID, PlayerInScene, Scene,
  SurfaceID,
  TerrainBrushID,
  TerrainCanvas,
  TerrainCanvasID, TerrainChunk, TerrainChunkEvent, TerrainStroke, TheatrePosition, ToolStateRaw
} from "../../defs";
import { idDef, MapAction, mapActionDef, MapEvent } from "@kosmod/kit";
import { PlayerID } from "@kosmod/sesame";
import { K3D } from "../../../graphics_3d/defs";
import { AnyLogicState } from "../../defs/logic/all";
import { DiceTemplateID } from "@kosmod/andy";

export type RawSessionAction = Shape.Type.Of<typeof RawSessionAction>;

const RawSessionAction = s.du('type', {
  // Request a particular scene to be loaded. GM-only
  'load-scene': { sceneId: idDef },
  // Mini actions
  'place-mini': { position: TheatrePosition.def, rotation: s.num, logic: s.a(AnyLogicState) },
  'move-mini': { miniId: idDef, position: TheatrePosition.def, animation: s.optional(MiniAnimation) },
  'set-mini-logic': { miniId: idDef, logicIndex: s.num, logicState: AnyLogicState },
  'remove-mini': { miniId: idDef },
  // terrain actions
  'add-canvas': { surface: SurfaceID, palette: s.optional(s.a(TerrainBrushID)) },
  'update-canvas-palette': { surface: SurfaceID, palette: s.optional(s.a(TerrainBrushID)) },
  // 'draw-terrain-chunk': { add: s.a(TerrainChunk), update: s.a(TerrainChunk), remove: s.a(s.t([TerrainCanvasID, s.num, s.num])) },

  'paint-strokes': { strokes: s.a(TerrainStroke) },

  'add-die': { diceTemplateId: DiceTemplateID, initialTransform: K3D.Transform },
  'remove-die': { physicsDieId: PhysicsDiceID },

  'sync': { cursor: s.optional(TheatrePosition.def), dice: s.optional(s.a(s.t([PhysicsDiceID, K3D.Transform]))) },
  'set-player-tool': { tool: s.optional(ToolStateRaw) },
});

export const Actions = {
  placeMini: (position: TheatrePosition, rotation: number, logic: AnyLogicState[]): RawSessionAction => ({
    type: 'place-mini',
    position,
    rotation,
    logic,
  }),
  moveMini: (miniId: MiniID, position: TheatrePosition, animation: MiniAnimation | null = null): RawSessionAction => ({
    type: 'move-mini', miniId, position, animation
  }),
  setMiniLogic: (miniId: MiniID, logicIndex: number, logicState: AnyLogicState): RawSessionAction => ({
    type: 'set-mini-logic', miniId, logicIndex, logicState
  }),
  addCanvas(surface: SurfaceID, palette: TerrainBrushID[] | null): RawSessionAction {
    return { type: 'add-canvas', surface, palette }
  },
  // drawTerrainChunk(add: TerrainChunk[], update: TerrainChunk[], remove: [TerrainCanvasID, number, number][]): RawSessionAction {
  //   return { type: 'draw-terrain-chunk', add, update, remove }
  // },
  sync(cursor: null | TheatrePosition, dice: null | [PhysicsDiceID, K3D.Transform][] = null): RawSessionAction {
    return { type: 'sync', cursor, dice }
  },
  playerTool(tool: null | ToolStateRaw) {
    return { type: 'set-player-tool', tool }
  }
}

export type SceneSessionAction = Shape.Type.Of<typeof SceneSessionAction>;
export const SceneSessionAction = s.o({
  a: RawSessionAction,
  meta: s.optional(s.o({
    actionSeq: s.optional(s.num),
  })),
});